/**
 * NoteFooter Component
 * Sticky footer with Save Note button
 */

import React from 'react';
import { View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { Button } from '@/components/ui/button';

export interface NoteFooterProps {
  /** Callback when save button is pressed */
  onSubmit: () => void;
  /** Whether the save button is enabled */
  isEnabled?: boolean;
  /** Whether saving is in progress */
  isSubmitting?: boolean;
  /** Number of saveable entries (drives dynamic button text) */
  entryCount?: number;
}

export function NoteFooter({
  onSubmit,
  isEnabled = false,
  isSubmitting = false,
  entryCount = 1,
}: NoteFooterProps) {
  const insets = useSafeAreaInsets();

  const buttonText =
    entryCount <= 1
      ? 'Save Note'
      : `Save ${entryCount} Notes`;

  return (
    <View
      className="px-4 pt-3 border-t bg-background border-border"
      style={{ paddingBottom: Math.max(insets.bottom, 16) }}
    >
      <Button
        onPress={onSubmit}
        disabled={!isEnabled || isSubmitting}
        loading={isSubmitting}
        variant="primary"
        fullWidth
        accessibilityLabel={buttonText}
      >
        {buttonText}
      </Button>
    </View>
  );
}

export default NoteFooter;
